import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useTransparentImage } from '../hooks/useTransparentImage';
export const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/o9bGNLdS3yo2HujevTULFP/WhatsApp_Image_2026-08-22_at_5.55.55_AM_(1).jpg';

/* The artwork sits on a black canvas with a small margin, so the mark is cropped to its content box. */
const CROP = {
  left: 0.039,
  top: 0.063,
  width: 0.929,
  height: 0.865
};
const SOURCE_RATIO = 399 / 1017;

/* Same lockup with the wordmark in graphite — used on the light header. */
export const HEADER_LOGO_URL = 'https://cdn.magicpatterns.com/uploads/mnrs3D87ASw9xrLhUSGYfr/WhatsApp_Image_2026-08-22_at_5.55.55_AM.jpg';
type LogoMarkProps = {
  width?: number;
  className?: string;
  src?: string;
};
export function LogoMark({
  width = 124,
  className = '',
  src = LOGO_URL
}: LogoMarkProps) {
  const imageWidth = width / CROP.width;
  const imageHeight = imageWidth * SOURCE_RATIO;
  const boxHeight = imageHeight * CROP.height;
  const transparentSrc = useTransparentImage(src);
  return <span className={`relative block overflow-hidden ${className}`} style={{
    width,
    height: boxHeight
  }} data-id="element-22" data-mp="1ex4304ai4ht8">
      <img src={transparentSrc} alt="Standard Consulting Advice" className="absolute max-w-none" style={{
      width: imageWidth,
      height: imageHeight,
      left: -imageWidth * CROP.left,
      top: -imageHeight * CROP.top
    }} data-id="element-23" data-mp="1nvg1eshm0jw8" />
    </span>;
}

/* Original artwork on a white canvas — used where the logo sits on a light plate. */
const LIGHT_LOGO_URL = 'https://cdn.magicpatterns.com/uploads/tHdWwGui1BVhGPnZQ6y9k5/WhatsApp_Image_2026-07-30_at_4.14.54_PM.jpg';
const LIGHT_CROP = {
  left: 0.2072,
  top: 0.2917,
  width: 0.5903,
  height: 0.3596
};
const LIGHT_SOURCE_RATIO = 737 / 1279;
export function LogoMarkOnWhite({
  width = 200,
  className = ''
}: LogoMarkProps) {
  const imageWidth = width / LIGHT_CROP.width;
  const imageHeight = imageWidth * LIGHT_SOURCE_RATIO;
  const boxHeight = imageHeight * LIGHT_CROP.height;
  return <span className={`relative block overflow-hidden ${className}`} style={{
    width,
    height: boxHeight
  }} data-id="element-24" data-mp="1e6yxbgo2ivzc">
      <img src={LIGHT_LOGO_URL} alt="Standard Consulting Advice" className="absolute max-w-none" style={{
      width: imageWidth,
      height: imageHeight,
      left: -imageWidth * LIGHT_CROP.left,
      top: -imageHeight * LIGHT_CROP.top
    }} data-id="element-25" data-mp="1i8am5jz4bd6h" />
    </span>;
}
type LogoProps = {
  variant?: 'dark' | 'light';
};
export function Logo({
  variant = 'dark'
}: LogoProps) {
  const {
    t
  } = useLanguage();
  return <a href="#top" aria-label={t.nav.homeLabel} className="inline-flex items-center transition-transform duration-300 hover:-translate-y-0.5" data-id="element-26" data-mp="25xv88bqkiqjz">
      <LogoMark width={variant === 'dark' ? 128 : 160} src={variant === 'dark' ? HEADER_LOGO_URL : LOGO_URL} data-id="element-27" data-mp="7kbsd66bicmc" />
    </a>;
}